import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ControlBase } from '../control-base';
import { ControlService } from "../../services/control.service";
import { BreakpointObserver } from '@angular/cdk/layout';
import { CdkStep } from "@angular/cdk/stepper";



@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {

  @Input() controls: ControlBase<string>[] | null = [];
  form!: FormGroup;
  isEditable: boolean = true;
  isSmallScreen: Observable<boolean>;
  constructor(
    private controlService: ControlService,
    private breakpointObserver: BreakpointObserver,
    private step: CdkStep
  ) {
    this.isSmallScreen = this.breakpointObserver
      .observe('(min-width: 900px)')
      .pipe(map(({ matches }) => (matches ? true : false)));
  }

  ngOnInit(): void {
    this.form = this.controlService.toFormGroup(this.controls as ControlBase<string>[]);
    this.step.stepControl = this.form;
  }

  ngOnChanges(): void {
    this.form = this.controlService.toFormGroup(this.controls as ControlBase<string>[]);
    this.step.stepControl = this.form;
    this.step.reset();
  }

}
